// ** api slice import
import { slices } from '../../app/slice';

// ** api routes for document management
const routes = {
  UPLOAD_TAX_FILE_DOCUMENT: '/documents/tax-file/:taxFileId/upload',
  UPLOAD_QUIZ_RESPONSE_DOCUMENT:
    '/documents/quiz-response/:quizResponseId/upload',
  DOWNLOAD_DOCUMENT: '/documents/:documentId/download',
  DELETE_DOCUMENT: '/documents/:documentId',
  GET_USER_DOCUMENTS: '/documents/user-documents',
  GET_TAX_FILE_DOCUMENTS: '/documents/tax-file/:taxFileId/documents',
  UPDATE_TAX_FILE_DOCUMENTS: '/documents/tax-file/:taxFileId/documents',
};

// ** slice for document management
const documentsApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    uploadTaxFileDocument: builder.mutation({
      query: ({ taxFileId, formData }) => ({
        url: routes.UPLOAD_TAX_FILE_DOCUMENT.replace(':taxFileId', taxFileId),
        method: 'POST',
        body: formData,
        formData: true,
      }),
    }),
    uploadQuizResponseDocument: builder.mutation({
      query: ({ quizResponseId, formData }) => ({
        url: routes.UPLOAD_QUIZ_RESPONSE_DOCUMENT.replace(
          ':quizResponseId',
          quizResponseId
        ),
        method: 'POST',
        body: formData,
        formData: true,
      }),
      invalidatesTags: ['Document'],
    }),
    getDocumentDownloadUrl: builder.mutation({
      query: documentId => ({
        url: routes.DOWNLOAD_DOCUMENT.replace(':documentId', documentId),
        method: 'POST',
      }),
    }),
    deleteDocument: builder.mutation({
      query: documentId => ({
        url: routes.DELETE_DOCUMENT.replace(':documentId', documentId),
        method: 'DELETE',
      }),
    }),
    getUserDocuments: builder.query({
      query: ({ page, limit, documentType, status }) => ({
        url: routes.GET_USER_DOCUMENTS,
        params: { page, limit, documentType, status },
      }),
    }),
    getTaxFileDocuments: builder.query({
      query: ({ taxFileId, questionId }) => ({
        url: routes.GET_TAX_FILE_DOCUMENTS.replace(':taxFileId', taxFileId),
        params: { questionId: questionId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    updateTaxFileDocuments: builder.mutation({
      query: ({ taxFileId, documentUpdates, documentAdditions }) => ({
        url: routes.UPDATE_TAX_FILE_DOCUMENTS.replace(':taxFileId', taxFileId),
        method: 'PUT',
        body: { documentUpdates, documentAdditions },
      }),
    }),
  }),
});

export const {
  useUploadTaxFileDocumentMutation,
  useUploadQuizResponseDocumentMutation,
  useGetDocumentDownloadUrlMutation,
  useDeleteDocumentMutation,
  useGetUserDocumentsQuery,
  useGetTaxFileDocumentsQuery,
  useUpdateTaxFileDocumentsMutation,
} = documentsApiSlice;
